import { Outlet } from '@tanstack/react-router'
import { useRuntimeVariables } from 'app-kit'
import { RightDrawerProvider } from 'components/rightDrawer/utils/RightDrawerProvider'
import { GeckoAnalyticsProvider } from 'features/analytics'
import { useGeckoAuth } from 'features/auth'
import { DataLayerProvider } from 'features/dataLayers'
import { DSAPIProvider } from 'features/dsapi'
import { DuckDbInstanceProvider } from 'features/duckDB'
import { GeckoLocaleProvider } from 'features/locale'
import { RolodexProvider } from 'features/rolodex'
import { PERMISSIONS_REQUIRING_TERMS, useTermsModal } from 'features/terms'
import { TermsModal } from 'pages/terms/TermsModal'
import React, { useEffect, useState } from 'react'

export const LoggedInContent: React.FC = () => {
  const { DS_API_URL, ROLODEX_URL, ENVIRONMENT } = useRuntimeVariables()

  const { permissions } = useGeckoAuth()
  const [termsAccepted, setTermsAccepted] = useState<boolean>(false)
  const { showToSModal, setShowToSModal } = useTermsModal()
  const requiredToAccept = PERMISSIONS_REQUIRING_TERMS.some((perm) =>
    permissions?.has(perm)
  )

  useEffect(() => {
    const accepted = localStorage.getItem('termsAccepted')
    if (accepted) {
      setTermsAccepted(true)
    } else if (requiredToAccept) {
      setShowToSModal(true)
    }
  }, [requiredToAccept, setShowToSModal])

  const handleAccept = () => {
    localStorage.setItem('termsAccepted', 'true')
    setTermsAccepted(true)
    setShowToSModal(false)
  }

  const handleClose = () => {
    setShowToSModal(false)
  }

  const needsToAccept = requiredToAccept && !termsAccepted

  return (
    <GeckoLocaleProvider>
      <GeckoAnalyticsProvider env={ENVIRONMENT}>
        <DSAPIProvider apiURL={DS_API_URL}>
          <RolodexProvider apiURL={ROLODEX_URL}>
            <DataLayerProvider apiURL={ROLODEX_URL}>
              <DuckDbInstanceProvider>
                <RightDrawerProvider>
                  {(showToSModal || needsToAccept) && (
                    <TermsModal
                      requiredToAccept={needsToAccept}
                      onAccept={handleAccept}
                      onClose={handleClose}
                    />
                  )}
                  <Outlet />
                </RightDrawerProvider>
              </DuckDbInstanceProvider>
            </DataLayerProvider>
          </RolodexProvider>
        </DSAPIProvider>
      </GeckoAnalyticsProvider>
    </GeckoLocaleProvider>
  )
}
